<div mat-dialog-title>
  <div class="d-flex justify-content-between">
    Enter code
    <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <form [formGroup]="OTPVerificationForm" autocomplete="off">
    <div class="row m-0 eip-pt-20"
      style="padding: 20px;text-align: center;align-items: center;justify-content: center;margin-bottom: 10px;">
      <p>We sent OTP to {{ShowMailID}} Please enter the code to sign in.</p>
      <br>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"
        style="align-items: center;justify-content: center;">
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>Code</mat-label>
          <input matInput formControlName="Code" required>
          <mat-error *ngIf=" (OTPVerificationForm.get('Code').dirty || 
          OTPVerificationForm.get('Code').touched) && 
          OTPVerificationForm.get('Code').hasError('required')">
            Code is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
    <button (click)="saveProject()" class="btn btn-primary" [disabled]="!OTPVerificationForm.valid" type="submit"
      id="btnEDMSave">{{actionButtonText}}</button>&nbsp;
    <button (click)="closeDialog()" class="btn btn-secondary" id="btnEDMCancel">Cancel</button>
  </div>
</div>